import { BotOff, FileText, Mail, MessageCircle, PencilRuler, Send, Tags } from "lucide-react"
import { ActionTypeEnum } from "schema"

export const ActionIconMap = {
  [ActionTypeEnum.SendWebhook]: Send,
  [ActionTypeEnum.CreateZendeskTicket]: FileText,
  [ActionTypeEnum.CreateGorgiasTicket]: FileText,
  [ActionTypeEnum.CreateFrontAppTicket]: FileText,
  [ActionTypeEnum.SendInternalEmail]: Mail,
  [ActionTypeEnum.SendInConversationMessage]: MessageCircle,
  [ActionTypeEnum.TriggerCapability]: PencilRuler,
  [ActionTypeEnum.DisableAgent]: BotOff,
  [ActionTypeEnum.UpdateCustomerTags]: Tags,
}
